module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Button",
    class: _vm.buttonClasses
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c5346c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 380
// module chunks = 1